import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef, TemplateRef, ViewChild } from "@angular/core";
import { map, Subject, takeUntil } from "rxjs";
import { IUsers } from "@alpha/types";
import { AdminService } from "app-service";
import { ColumnDefinition, ColumnTemplateType, Icon } from "app-core";
import { MatTableDataSource } from "@angular/material/table";

import IconType = Data.Core.IconType;

@Component({
  selector: 'app-mr',
  templateUrl: './medical-representatives.component.html',
  styleUrls: ['./medical-representatives.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [AdminService]
})
export class MedicalRepresentativesComponent implements OnInit {
  @ViewChild('contactColumn', { static: true }) public contactColumn?: TemplateRef<any>;
  @ViewChild('emailColumn', { static: true }) public emailColumn?: TemplateRef<any>;
  public userList!: Array<IUsers>;
  public displayedColumns: Array<ColumnDefinition> = [];
  public phoneIcon: Icon = new Icon({
    icon: IconType.phoneIcon,
    hover: true,
    badge: {
      size: 'small',
      color: 'accent',
      content: '',
    },
    tooltip: 'Call'
  });
  public editIcon: Icon = new Icon({
    icon: IconType.editModeIcon,
    hover: true,
    badge: {
      size: 'small',
      color: 'accent',
      content: '',
    },
    tooltip: 'Call'
  });
  public dataSource = new MatTableDataSource(this.userList);
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  public constructor(
    private readonly _adminService: AdminService,
    private readonly _cdRef: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this.getAllMRs();
    this.getDisplayedColumns();
  }

  public getDisplayedColumns(): void {
    this.displayedColumns = [
      {
        id: '#',
        displayName: '#',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 5
      },
      {
        id: 'Name',
        displayName: 'Name',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 15
      },
      {
        id: 'Contact',
        displayName: 'Contact',
        templateType: ColumnTemplateType.Custom,
        template: this.contactColumn,
        requestedWidth: 10
      },
      {
        id: 'Email',
        displayName: 'Email',
        templateType: ColumnTemplateType.Custom,
        template: this.emailColumn,
        requestedWidth: 25
      },
      {
        id: 'ReferralCode',
        displayName: 'Referral Code',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 20
      },
      {
        id: 'TotalRegistrations',
        displayName: 'Total Registrations',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 10
      },
      {
        id: 'Subscribed',
        displayName: 'Subscribed',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 10
      },
    ];
  }

  private getAllMRs(): void {
    this._adminService.getAllMRs()
      .pipe(
        map((users: Array<any>) => {
          let responseObj: any[] = [];
          if (users.length > 0) {
            users.forEach((user: any, index: number) => {
              responseObj.push({
                '_id': user._id,
                '#': `${index + 1}`,
                'Name': `${user.firstName} ${user.lastName}`,
                'Contact': `tel:${user.contact}`,
                'Email': `email:${user.email}`,
                'ReferralCode': `${user.referralCode}`,
                'TotalRegistrations': `${user.totalRegistrations}`,
                'Subscribed': `${user.subscribed}`
              });
            })
            return responseObj;
          }
          return responseObj;
        }),
        takeUntil(this.ngUnsubscribe))
      .subscribe((users: Array<IUsers>) => {
        if (users!.length > 0) {
          this.userList = users;
          this.dataSource = new MatTableDataSource(this.userList);
          this._cdRef.markForCheck();
        }
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
